"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationType = exports.Notification = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactHotToast = _interopRequireDefault(require("react-hot-toast"));
var _lodash = require("lodash");
var _Icon = require("../Icon");
var _IconButton = require("../Button/IconButton");
var _NotificationIconsByT;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var NotificationType = /*#__PURE__*/function (NotificationType) {
  NotificationType["Success"] = "success";
  NotificationType["Info"] = "info";
  NotificationType["Error"] = "error";
  return NotificationType;
}({});
exports.NotificationType = NotificationType;
var NotificationIconsByType = (_NotificationIconsByT = {}, _defineProperty(_NotificationIconsByT, NotificationType.Success, 'success-24'), _defineProperty(_NotificationIconsByT, NotificationType.Info, 'info'), _defineProperty(_NotificationIconsByT, NotificationType.Error, 'alert'), _NotificationIconsByT);
var Notification = function Notification(_ref) {
  var t = _ref.t,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? NotificationType.Success : _ref$type,
    title = _ref.title,
    description = _ref.description,
    onClick = _ref.onClick;
  var iconType = NotificationIconsByType[type];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('relative w-[344px] bg-white rounded-r-[8px] shadow-15', 'border-0 border-solid border-t border-b border-r border-grey-15', t.visible ? 'animate-enter' : 'animate-leave', {
      'cursor-pointer': (0, _lodash.isFunction)(onClick)
    }, {
      'text-green2-50': type === NotificationType.Success
    }, {
      'text-infoblue-60': type === NotificationType.Info
    }, {
      'text-alertred-60': type === NotificationType.Error
    }),
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(
    // Height covers up top and bottom border
    'absolute w-[8px] top-[-1px] left-0 h-[calc(100%+2px)]', {
      'bg-green2-40': type === NotificationType.Success
    }, {
      'bg-infoblue-60': type === NotificationType.Info
    }, {
      'bg-alertred-60': type === NotificationType.Error
    })
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex justify-between items-start py-[12px] pl-[22px] pr-[16px]"
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    type: iconType
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "tw-caption-light ml-[12px] w-[230px] pt-[4px]"
  }, title && /*#__PURE__*/_react.default.createElement("span", {
    className: "tw-caption-medium"
  }, title, " "), description && /*#__PURE__*/_react.default.createElement("span", {
    className: "text-black"
  }, description)), /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, {
    icon: "close-16",
    className: "text-grey-75 ml-[14px]",
    onClick: function onClick(e) {
      _reactHotToast.default.dismiss(t.id);
      e.stopPropagation();
    }
  })));
};
exports.Notification = Notification;